import polygan from "../gif/mapGif.gif";

export const weatherStationFormSteps = (ref1, ref2, ref3) => [
  {
    title: "ثبت موقعیت  ایستگاه",

    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "موقعیت دقیق ایستگاه هواشناسی خود را روی نقشه مشخص کنید. دقت داشته باشید که ایستگاه هواشناسی شما باید در محدوده زمین‌های شما ثبت شوند. ",
    target: () => ref1.current,
  },
  {
    title: "فرم اطلاعات ایستگاه",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    description:
      "سپس سایر اطلاعات ایستگاه را در این قسمت تکمیل کرده و بر روی دکمه ثبت ایستگاه کلیک کنید.",
    target: () => ref2.current,
  },
];

export const weatherStationListSteps = (ref1, ref2) => [
  {
    title: "افزودن ایستگاه ",

    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "با کلیک بر روی این قسمت میتوانید ایستگاه هواشناسی جدید ثبت نمائید. ",
    target: () => ref1.current,
  },
  {
    title: " لیست ایستگاه‌های شما ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    description:
      "در این قسمت شما میتوانید ایستگاه‌های ثبت شده خود را مشاهده نمائید. ",
    target: () => ref2.current,
  },
];

export const stationDetails = (ref1, ref2, ref3,ref4,ref5) => [
  {
    title: " ربات پیش آگاهی ",

    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "در این قسمت، هشدارها و پیش آگاهی‌های مربوط به ایستگاه هواشناسی شما نمایش داده می‌شود.",
    target: () => ref1.current,
  },
  {
    title: "   اطلاعات اقلیمی 30 ساله ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "در این قسمت میتوانید فایل اکسل اطلاعات اقلیمی ایستگاه هواشناسی خود را دانلود نمائید. همچنین دریافت سایر خدمات از اگرویار نیز بر اساس اطلاعات اقلیمی خودتان خواهد بود. ",
    target: () => ref2.current,
  },
  {
    title: "وضعیت هوای الان",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "بعدی",
    },
    description:
    "در این قسمت، وضعیت آب و هوایی حال حاضر محدوده ایستگاه هواشناسی شما نمایش داده می‌شود.",
        target: () => ref3.current,
  },
  {
    title: "وضعیت 24 ساعت آینده  ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "بعدی",
    },
    description:
"دراین قسمت، وضعیت آب و هوایی 24 ساعت آینده ایستگاه هواشناسی شما نمایش داده می‌شود.",
    target: () => ref4.current,
  },
  {
    title: "وضعیت 16 روز آینده  ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    description:
"در این قسمت، وضعیت آب و هوایی 16 روز آینده ایستگاه هواشناسی شما نمایش داده می‌شود. با کلیک روی هر روز میتوانید جزئیات بیشتری را مشاهده نمائید.",
    target: () => ref5.current,
  },
];
